module.exports = __webpack_public_path__ + "img/nupkg.edb508bd.svg";